module.exports = __webpack_public_path__ + "img/159.bde6af4b.jpg";